import { Identifier } from "../../id";
export class ModifierItemTypeId extends Identifier {
    constructor(id) {
        super("ModifierItemTypeId", id);
    }
}
